<template>
  <div class="klickbox-auth-loader">
    <div class="klickart-loader-container">
      <div class="klickart-loader"></div>
      <div class="klickbox-auth-label">Aguarde...</div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('authInit');
  },
};
</script>



/** WEBPACK FOOTER **
 ** Auth.vue?097b502e
 **/